<template>
  <div id="allbots" :style="{ '--text-color': 'black' }">
    <div id="main">
      <!-- $store.state.userid -->

      <div>
        <div>
          <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; height: 100vh">
            <vue-particles
              color="#ffffff"
              :particle-opacity="0.27"
              :particles-number="24"
              shape-type="circle"
              :particle-size="3"
              lines-color="#ffffff"
              :lines-width="1.1"
              :line-linked="true"
              :line-opacity="0.33"
              :lines-distance="192"
              :move-speed="1.6"
              :hover-effect="false"
              :click-effect="false"
            ></vue-particles>
          </div>
          <div v-show="!isLoading" class="accounts" style="z-index: 2">
            <v-toolbar flat color="transparent" style="background: transparent">
              <v-spacer></v-spacer>
              <div v-if="isZwizSuperAdmin" class="form-control">
                <div class="hidden-xs-only">
                  <v-layout>
                    <input
                      v-model="search"
                      type="text"
                      :placeholder="$t('Search')"
                      class="mb-0 pa-1"
                      style="line-height: 21px"
                      :disabled="loading"
                      @blur="onSearch"
                      @keyup.enter="$refs.searchbtn.$el.click()"
                    />
                    <v-btn
                      ref="searchbtn"
                      small
                      fab
                      depressed
                      color="primary"
                      :loading="loading"
                      @click="onSearch"
                    >
                      <v-icon small>search</v-icon>
                    </v-btn>
                  </v-layout>
                </div>
                <div class="hidden-sm-and-up">
                  <v-btn small fab depressed color="primary" @click="showSearch = true">
                    <v-icon small>search</v-icon>
                  </v-btn>
                  <v-dialog v-model="showSearch" max-width="600">
                    <v-card>
                      <div class="text-xs-right">
                        <v-btn small fab flat @click="showSearch = false"
                          ><v-icon>close</v-icon></v-btn
                        >
                      </div>
                      <v-card-text>
                        <div class="form-control">
                          <input
                            v-model="search"
                            type="text"
                            :placeholder="$t('Search')"
                            class="mb-0 pa-1"
                            style="line-height: 21px"
                            :disabled="loading"
                            @blur="onSearch"
                          />
                        </div>
                        <div class="text-xs-center">
                          <v-btn depressed color="primary" :loading="loading" @click="onSearch">
                            <v-icon small>search</v-icon> {{ $t('Search') }}
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </div>
              </div>
              <change-password v-if="!isDeltaAdmin"></change-password>

              <!-- <router-link
                :to="'/' + $i18n.locale() + '/partner'"
                class="link link-white"
                style="font-size: 18px"
                v-if="$store.state.partner_code && selectedBot.pagetype !== 'enterprise'"
              >
                <v-btn depressed color="green" dark style="line-height: 10px">
                  <v-icon class="mr-2" small>stars</v-icon>Partner Portal
                </v-btn>
              </router-link> -->

              <v-btn
                flat
                fab
                icon
                small
                class="hidden-sm-and-up"
                style="line-height: 10px"
                @click="logout"
              >
                <v-icon>power_settings_new</v-icon>
              </v-btn>
              <v-btn
                flat
                class="primary hidden-xs-only mr-4"
                style="line-height: 10px"
                @click="logout"
                >{{ $t('Sign Out') }}</v-btn
              >
              <lang-dropdown></lang-dropdown>
            </v-toolbar>

            <img
              :src="$store.state.theme.logo"
              alt="Mega Bangna"
              :style="{
                display: 'block',
                maxHeight: '128px',
                margin: '3rem auto'
              }"
            />

            <div class="text-xs-center">
              <h3 class="display-2 mt-4" style="color: var(--text-color)">
                {{ $t('Select bot to manage') }}
              </h3>
            </div>

            <v-container>
              <template v-if="isZwizSuperAdmin">
                <AccountForZwizAdminVue :item-per-page="itemPerPage" :dirty-search="dirtySearch" />
              </template>
              <template v-else>
                <AccountForAdmin :item-per-page="itemPerPage" @onAddBot="isAdd = true" />
              </template>
            </v-container>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="showSupport" scrollable max-width="600" persistent>
      <v-card>
        <div class="text-xs-center pa-2 pt-3">
          <div class="title primary--text">{{ $t('You want to use a Redeem Code') }}</div>
          <div
            class="pa-2 my-2 mx-auto"
            style="background: #eee; border-radius: 50px; max-width: 400px"
          >
            {{ supportcode }}
          </div>
          {{ $t('with page') }}
        </div>
        <v-divider />
        <v-card-text max-height="600">
          <template v-for="(bot, index) in botlist">
            <div :key="bot.pageid" class="pa-2">
              <v-layout>
                <BotLogoManager :bot="bot">
                  <template #logo="{ pageLogo }">
                    <v-avatar :size="50">
                      <img :src="pageLogo" />
                    </v-avatar> </template
                ></BotLogoManager>
                <v-flex class="pa-2">{{ bot.pagename }}</v-flex>
                <v-btn
                  color="primary"
                  :loading="loadingSupport"
                  small
                  depressed
                  @click="useRedeemCode(bot.pageid)"
                  >{{ $t('Apply') }}</v-btn
                >
              </v-layout>
            </div>
            <v-divider v-if="botlist.length - 1 != index" :key="bot.pageid + '_divider'" />
          </template>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            :loading="loadingSupport"
            @click="
              showSupport = false
              clearSupportCode()
            "
            >{{ $t("I don't want to use it for now") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isAdd" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <template v-if="$store.state.isLoggedIn">
          <div id="get-started">
            <get-started @close="isAdd = false"></get-started>
          </div>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import LangDropdown from '@/components/elements/LangDropdown'
import GetStarted from '@/components/view/getstarted/GetStarted'
import BotLogoManager from '@/components/elements/BotLogoManager'
import ChangePassword from './ChangePassword.vue'
import AccountForAdmin from './AccountForAdmin.vue'
import AccountForZwizAdminVue from './AccountForZwizAdmin.vue'

export default {
  name: 'AccountView',
  components: {
    GetStarted,
    LangDropdown,
    ChangePassword,
    BotLogoManager,
    AccountForAdmin,
    AccountForZwizAdminVue
  },
  data: function () {
    return {
      pageNumber: 1,
      itemPerPage: 100,
      pagelist: this.$store.state.pagelist,
      isLoading: true,
      isAdd: false,
      themelist: [],
      search: '',
      dirtySearch: '',
      botCount: 0,
      showDialogPageInfo: false,
      currentPageInfo: null,
      showCopy: false,
      loading: false,
      botFound: [],
      showSupport: false,
      supportcode: '',
      loadingSupport: false,
      loadingSearch: false,
      showSearch: false,
      currentAccounts: [],
      offset: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      isFacebook: 'isFacebook',
      currentLang: 'currentLang'
    }),
    filterBots() {
      if (this.isZwizSuperAdmin) {
        return this.botFound
      } else {
        return this.botlist
      }
    },
    isZwizUser() {
      return this.$store.state.userid.includes('zwiz')
    },
    isZwizSuperAdmin() {
      return this.$store.state.userid === 'zwizadmin'
    },
    hasDelta() {
      return (
        this.$store.state.botlist &&
        this.$store.state.botlist.some((bot) => bot.pageid === '704198559717443')
      )
    },
    isDeltaAdmin() {
      return this.hasDelta && !this.isZwizUser && this.$store.state.privilege.role === 'admin'
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal && !newVal.length) this.botFound = []
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    }
  },
  mounted: async function () {
    let vm = this
    vm.$store.dispatch('loading')

    if (this.$route.query.supportcode) this.supportcode = this.$route.query.supportcode

    await vm.getAllPublicTheme()
    vm.$store.dispatch('updatePagelist')

    if (vm.isFacebook) {
      let pageidlist = vm.pagelist
        .map((val) => {
          if (val.perms) {
            if (val.perms.indexOf('ADMINISTER') > -1 || val.perms.indexOf('EDIT_PROFILE') > -1) {
              return val.id
            }
          }
          if (val.tasks) {
            if (val.tasks.indexOf('MANAGE') > -1 || val.tasks.indexOf('CREATE_CONTENT') > -1) {
              return val.id
            }
          }
          return null
        })
        .filter(Boolean)

      // get bot list by user id
      let data = {
        userid: vm.$store.state.userid,
        pageidlist: pageidlist,
        access_token: vm.$store.state.fbAccessToken
      }
      try {
        await vm.$store.dispatch('getBotlist', data)
        vm.$store.dispatch('loading')
        vm.isLoading = false
        if (!vm.botlist || vm.botlist.length <= 0) {
          vm.isAdd = true
        } else {
          if (vm.$route.query.supportcode) {
            vm.showSupport = true
          }
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    } else {
      vm.$store.dispatch('loading')
      vm.isLoading = false
      if (!vm.botlist || vm.botlist.length <= 0) {
        vm.isAdd = true
      }
    }
  },

  methods: {
    async useRedeemCode(pageid) {
      this.loadingSupport = true
      try {
        var response = await this.onSaveRedeem(pageid, this.supportcode)
        // console.log(response)
        var day = parseInt(response.extend)
        var latest_date = moment(response.expireat)
        response.package = response.isPass ? response.code : '-'

        if (response.responsecode == 200 && response.isPass) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('you got {day} days Premium Package', {
              day: day
            }),
            text: `${this.$t('Expired Date')} ${latest_date.format('DD/MM/YYYY')}`
          })
          this.clearSupportCode()
          location.reload()
        } else if (
          response.responsecode == 401 ||
          (response.responsecode == 200 && !response.isPass)
        ) {
          let time = response.unlocktimestamp
          await this.$swal.fire({
            type: 'error',
            title: this.$t('This page has too many attempt'),
            text: this.$t(`Please try again after`) + ' ' + moment(time).format('DD/MM/YYYY HH:mm')
          })
          this.$localStorage.set('redeemlock', time)
          this.clearSupportCode()
          this.showSupport = false
        }
      } catch (error) {
        console.log(error)
      }
      this.loadingSupport = false
    },
    onSaveRedeem(pageid, code) {
      return new Promise((resolve) => {
        var data = { pageid: pageid, redeem: code.toUpperCase() }
        api.activateredeemcode(data, function (error, response) {
          if (response.responsecode == 200) {
            if (Object.hasOwnProperty.call(response, 'extend')) {
              response.isPass = true
              response.code = code
              resolve(response)
            } else {
              response.isPass = false
              response.code = code
              resolve(response)
            }
          } else if (response.responsecode == 401) {
            response.isPass = false
            response.code = code
            resolve(response)
          }
        })
      })
    },
    clearSupportCode() {
      // remove support code
      var query = { ...this.$route.query }
      delete query.supportcode
      this.$router.push({
        path: '/' + this.currentLang + '/allbots',
        query: query
      })
    },
    onSearch() {
      this.dirtySearch = this.search
    },
    onClickPageinate: function (pageNum) {
      this.pageNumber = pageNum
      // scroll to top
      window.scrollTo(0, 0)
    },
    logout: function () {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to Logout?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            var isFacebook = vm.isFacebook
            vm.$store.dispatch('logout', null).then()
            if (isFacebook) {
              vm.$router.push('/' + vm.currentLang + '/login')
            } else {
              vm.$router.push('/' + vm.currentLang + '/nigol')
            }
          }
        })
    },
    getAllPublicTheme: async function () {
      let vm = this
      vm.themelist = [
        {
          themeid: 'ecommercebasic',
          themename: 'ecommercebasic',
          description: '',
          themepic: '',
          ispublic: true
        }
      ]
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.v-icon {
  line-height: 0 !important;
  height: 0 !important;
}
.select-page {
  .page {
    transition: transform 0.3s ease-out;

    &:hover {
      transform: translate(0, -5px);

      .page-image img {
        box-shadow: 0px 3px 5px #00000021;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/allbots/Account.vue